<template>
    <div class="w-full h-full relative overflow-hidden">
        <div class="w-full h-full relative">
            <div class="w-full h-full flex overflow-y-auto overflow-hidden">
                <div v-if="error == 'not found'" id="not-found" class="w-full h-full transition-next flex-shrink-0">
                    <div
                        class="w-full h-full flex flex-col xl:flex-row items-center justify-center space-x-8 2xl:space-x-0">
                        <div class="w-full xl:w-1/2 flex flex-col items-center justify-center lg:px-2 xl:px-0 text-center">
                            <p class="text-7xl md:text-8xl lg:text-9xl font-bold tracking-wider text-gray-300">404</p>
                            <p class="text-4xl md:text-5xl lg:text-6xl font-bold tracking-wider text-gray-300 mt-2">{{
                                $t('articlenotfound') }}</p>
                            <p class="text-lg md:text-xl lg:text-2xl text-gray-500 my-3 xl:my-12 px-3 xl:px-0">{{
                                $t('messagearticlenotfound') }}</p>
                        </div>
                        <div class="w-full xl:w-1/2 xl:h-full flex lg:items-end justify-center p-4">
                            <svg class="w-full text-blue-600" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"
                                viewBox="0 0 1120.59226 777.91584" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <title>not found</title>
                                <circle cx="212.59226" cy="103" r="64" fill="#ff9900"></circle>
                                <path
                                    d="M563.68016,404.16381c0,151.01141-89.77389,203.73895-200.51559,203.73895S162.649,555.17522,162.649,404.16381,363.16457,61.04208,363.16457,61.04208,563.68016,253.1524,563.68016,404.16381Z"
                                    transform="translate(-39.70387 -61.04208)" fill="#cbd5e1"></path>
                                <polygon
                                    points="316.156 523.761 318.21 397.378 403.674 241.024 318.532 377.552 319.455 320.725 378.357 207.605 319.699 305.687 319.699 305.687 321.359 203.481 384.433 113.423 321.621 187.409 322.658 0 316.138 248.096 316.674 237.861 252.547 139.704 315.646 257.508 309.671 371.654 309.493 368.625 235.565 265.329 309.269 379.328 308.522 393.603 308.388 393.818 308.449 394.99 293.29 684.589 313.544 684.589 315.974 535.005 389.496 421.285 316.156 523.761"
                                    fill="#ff9900">
                                </polygon>
                                <path
                                    d="M1160.29613,466.01367c0,123.61-73.4842,166.77-164.13156,166.77s-164.13156-43.16-164.13156-166.77S996.16457,185.15218,996.16457,185.15218,1160.29613,342.40364,1160.29613,466.01367Z"
                                    transform="translate(-39.70387 -61.04208)" fill="#cbd5e1"></path>
                                <polygon
                                    points="950.482 552.833 952.162 449.383 1022.119 321.4 952.426 433.154 953.182 386.639 1001.396 294.044 953.382 374.329 953.382 374.329 954.741 290.669 1006.369 216.952 954.954 277.514 955.804 124.11 950.467 327.188 950.906 318.811 898.414 238.464 950.064 334.893 945.173 428.327 945.027 425.847 884.514 341.294 944.844 434.608 944.232 446.293 944.123 446.469 944.173 447.428 931.764 684.478 948.343 684.478 950.332 562.037 1010.514 468.952 950.482 552.833"
                                    fill="#ff9900">
                                </polygon>
                                <ellipse cx="554.59226" cy="680.47903" rx="554.59226" ry="28.03433" fill="#3f3d56">
                                </ellipse>
                                <ellipse cx="892.44491" cy="726.79663" rx="94.98858" ry="4.80162" fill="#3f3d56"></ellipse>
                                <ellipse cx="548.71959" cy="773.11422" rx="94.98858" ry="4.80162" fill="#3f3d56"></ellipse>
                                <ellipse cx="287.94432" cy="734.27887" rx="217.01436" ry="10.96996" fill="#3f3d56">
                                </ellipse>
                                <circle cx="97.08375" cy="566.26982" r="79" fill="#2f2e41"></circle>
                                <rect x="99.80546" y="689.02332" width="24" height="43"
                                    transform="translate(-31.32451 -62.31008) rotate(0.67509)" fill="#2f2e41"></rect>
                                <rect x="147.80213" y="689.58887" width="24" height="43"
                                    transform="translate(-31.31452 -62.87555) rotate(0.67509)" fill="#2f2e41"></rect>
                                <ellipse cx="119.54569" cy="732.61606" rx="7.5" ry="20"
                                    transform="translate(-654.1319 782.47948) rotate(-89.32491)" fill="#2f2e41"></ellipse>
                                <ellipse cx="167.55414" cy="732.18168" rx="7.5" ry="20"
                                    transform="translate(-606.25475 830.05533) rotate(-89.32491)" fill="#2f2e41"></ellipse>
                                <circle cx="99.31925" cy="546.29477" r="27" fill="#fff"></circle>
                                <circle cx="99.31925" cy="546.29477" r="9" fill="#3f3d56"></circle>
                                <path
                                    d="M61.02588,552.94636c-6.04185-28.64075,14.68758-57.26483,46.30049-63.93367s62.13813,11.14292,68.18,39.78367-14.97834,38.93-46.59124,45.59886S67.06774,581.58712,61.02588,552.94636Z"
                                    transform="translate(-39.70387 -61.04208)" fill="#ff9900"></path>
                                <path
                                    d="M257.29613,671.38411c0,55.07585-32.73985,74.3063-73.13,74.3063q-1.40351,0-2.80255-.0312c-1.87139-.04011-3.72494-.1292-5.55619-.254-36.45135-2.57979-64.77127-22.79937-64.77127-74.02113,0-53.00843,67.73872-119.89612,72.827-124.84633l.00892-.00889c.19608-.19159.29409-.28516.29409-.28516S257.29613,616.30827,257.29613,671.38411Z"
                                    transform="translate(-39.70387 -61.04208)" fill="#ff9900"></path>
                                <path
                                    d="M181.50168,737.26482l26.747-37.37367-26.81386,41.4773-.07125,4.29076c-1.87139-.04011-3.72494-.1292-5.55619-.254l2.88282-55.10258-.0223-.42775.049-.0802.27179-5.20415-26.88076-41.5798,26.96539,37.67668.06244,1.105,2.17874-41.63324-23.0132-42.96551,23.29391,35.6583,2.26789-86.31419.00892-.294v.28516l-.37871,68.064,22.91079-26.98321-23.00435,32.84678-.60595,37.27566L204.18523,621.958l-21.4805,41.259-.33863,20.723,31.05561-49.79149-31.17146,57.023Z"
                                    transform="translate(-39.70387 -61.04208)" fill="#3f3d56"></path>
                                <circle cx="712.48505" cy="565.41532" r="79" fill="#2f2e41"></circle>
                                <rect x="741.77716" y="691.82355" width="24" height="43"
                                    transform="translate(-215.99457 191.86399) rotate(-17.08345)" fill="#2f2e41"></rect>
                                <rect x="787.6593" y="677.72286" width="24" height="43"
                                    transform="matrix(0.95588, -0.29376, 0.29376, 0.95588, -209.82788, 204.72037)"
                                    fill="#2f2e41"></rect>
                                <ellipse cx="767.887" cy="732.00275" rx="20" ry="7.5"
                                    transform="translate(-220.8593 196.83312) rotate(-17.08345)" fill="#2f2e41"></ellipse>
                                <ellipse cx="813.47537" cy="716.94619" rx="20" ry="7.5"
                                    transform="translate(-214.42477 209.56103) rotate(-17.08345)" fill="#2f2e41"></ellipse>
                                <circle cx="708.52153" cy="545.71023" r="27" fill="#fff"></circle>
                                <circle cx="708.52153" cy="545.71023" r="9" fill="#3f3d56"></circle>
                                <path
                                    d="M657.35526,578.74316c-14.48957-25.43323-3.47841-59.016,24.59412-75.0092s62.57592-8.34055,77.06549,17.09268-2.39072,41.6435-30.46325,57.63671S671.84483,604.17639,657.35526,578.74316Z"
                                    transform="translate(-39.70387 -61.04208)" fill="#ff9900"></path>
                                <path
                                    d="M611.29613,661.29875c0,50.55711-30.05368,68.20979-67.13,68.20979q-1.28835,0-2.57261-.02864c-1.71785-.03682-3.41933-.1186-5.10033-.23313-33.46068-2.36813-59.45707-20.92878-59.45707-67.948,0-48.65932,62.18106-110.05916,66.85186-114.60322l.00819-.00817c.18-.17587.27-.26177.27-.26177S611.29613,610.74164,611.29613,661.29875Z"
                                    transform="translate(-39.70387 -61.04208)" fill="#ff9900"></path>
                                <path
                                    d="M541.72029,721.77424l24.55253-34.30732-24.6139,38.07426-.0654,3.93872c-1.71785-.03682-3.41933-.1186-5.10033-.23313l2.6463-50.58165-.02047-.39266.045-.07361.24949-4.77718-24.67531-38.16836,24.753,34.58547.05731,1.01433,2-38.21741-21.12507-39.44039L541.80616,625.928l2.08182-79.23247.00819-.26994v.26177l-.34764,62.47962,21.031-24.76934-21.11693,30.15184-.55624,34.21735,19.63634-32.839-19.71812,37.87389-.31085,19.0228,28.50763-45.70631-28.614,52.34448Z"
                                    transform="translate(-39.70387 -61.04208)" fill="#3f3d56"></path>
                                <path
                                    d="M875.29613,682.38411c0,55.07585-32.73985,74.3063-73.13,74.3063q-1.4035,0-2.80255-.0312c-1.87139-.04011-3.72494-.1292-5.55619-.254-36.45135-2.57979-64.77127-22.79937-64.77127-74.02113,0-53.00843,67.73872-119.89612,72.827-124.84633l.00892-.00889c.19608-.19159.29409-.28516.29409-.28516S875.29613,627.30827,875.29613,682.38411Z"
                                    transform="translate(-39.70387 -61.04208)" fill="#ff9900"></path>
                                <path
                                    d="M799.50168,748.26482l26.747-37.37367-26.81386,41.4773-.07125,4.29076c-1.87139-.04011-3.72494-.1292-5.55619-.254l2.88282-55.10258-.0223-.42775.049-.0802.27179-5.20415L770.108,654.01076l26.96539,37.67668.06244,1.105,2.17874-41.63324-23.0132-42.96551,23.29391,35.6583,2.26789-86.31419.00892-.294v.28516l-.37871,68.064,22.91079-26.98321-23.00435,32.84678-.606,37.27566L822.18523,632.958l-21.4805,41.259-.33863,20.723,31.05561-49.79149-31.17146,57.023Z"
                                    transform="translate(-39.70387 -61.04208)" fill="#3f3d56"></path>
                                <ellipse cx="721.51694" cy="656.82212" rx="12.40027" ry="39.5"
                                    transform="translate(-220.83517 966.22323) rotate(-64.62574)" fill="#2f2e41"></ellipse>
                                <ellipse cx="112.51694" cy="651.82212" rx="12.40027" ry="39.5"
                                    transform="translate(-574.07936 452.71367) rotate(-68.15829)" fill="#2f2e41"></ellipse>
                            </svg>
                        </div>
                    </div>
                </div>
                <div v-if="error == ''" id="detail-page" class="w-full h-full relative transition-next flex-shrink-0">
                    <div class="w-full h-full py-2">
                        <div class="w-full h-full md:flex space-y-4 md:space-y-0">
                            <div class="md:h-full w-full space-y-4 md:space-y-0 xl:flex md:overflow-y-auto no-scrollbar">
                                <div class="xl:h-full xl:w-[50%] w-full flex ">
                                    <div class="w-[15%] h-full flex">
                                        <div v-if="article" class="mx-auto space-y-4">
                                            <div v-for="(image, imageKey) in images" :key="image" class="w-12 h-16 rounded-xl">
                                                <img @mouseover="imageSelect = image"
                                                    :class="image == imageSelect ? 'border-[2px] border-[#FF9900]' : ''"
                                                    class="rounded-xl w-full h-full object-cover hidden xl:block"
                                                    :src="$articleImage(article, imageKey, 'thumbnail')" alt="">
                                                <img @click="imageSelect = image"
                                                    :class="image == imageSelect ? 'border-[2px] border-[#FF9900]' : ''"
                                                    class="rounded-xl w-full h-full object-cover xl:hidden"
                                                    :src="$articleImage(article, imageKey, 'thumbnail')" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-[85%] h-full overflow-hidden px-3">
                                        <img class="w-full h-full object-contain"
                                            :src="imageSelect" alt="" srcset="">
                                    </div>
                                </div>
                                <div class="xl:h-full xl:w-[50%] w-full flex flex-col relative px-4 xl:px-0 ">
                                    <div class="w-full relative">
                                        <div>
                                            <h1 class="text-2xl font-semibold">{{ article.marque }} {{ article.nom }}</h1>
                                        </div>
                                        <div @click="viewProfil(user)">
                                            <p
                                                class="text-[#FF9900] hover:text-[#ffaa29] underline cursor-pointer font-semibold">
                                                {{ $t('visiterlaboutique') }} {{ user.name }}
                                            </p>
                                        </div>
                                        <div class="flex space-x-5 w-full border-b-[1px] border-gray-400">
                                            <div class="flex space-x-1">
                                                <p class=" font-semibold">{{ user.avis > 0 ? (user.etoile /
                                                    user.avis).toFixed(1)
                                                    : (0).toFixed(1) }}</p>
                                                <div class="flex">
                                                    <button>
                                                        <svg :class="(user.etoile / user.avis) >= 1 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'"
                                                            class="w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96"
                                                            version="1.1">
                                                            <g id="surface1">
                                                                <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
                                                                    d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z " />
                                                            </g>
                                                        </svg>
                                                    </button>
                                                    <button>
                                                        <svg :class="(user.etoile / user.avis) >= 2 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'"
                                                            class="w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96"
                                                            version="1.1">
                                                            <g id="surface1">
                                                                <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
                                                                    d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z " />
                                                            </g>
                                                        </svg>
                                                    </button>
                                                    <button>
                                                        <svg :class="(user.etoile / user.avis) >= 3 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'"
                                                            class="w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96"
                                                            version="1.1">
                                                            <g id="surface1">
                                                                <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
                                                                    d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z " />
                                                            </g>
                                                        </svg>
                                                    </button>
                                                    <button>
                                                        <svg :class="(user.etoile / user.avis) >= 4 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'"
                                                            class="w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96"
                                                            version="1.1">
                                                            <g id="surface1">
                                                                <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
                                                                    d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z " />
                                                            </g>
                                                        </svg>
                                                    </button>
                                                    <button>
                                                        <svg :class="(user.etoile / user.avis) >= 5 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'"
                                                            class="w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96"
                                                            version="1.1">
                                                            <g id="surface1">
                                                                <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
                                                                    d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z " />
                                                            </g>
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                            <p class="text-blue-500 font-semibold">{{ user.avis }} Evaluations</p>
                                        </div>
                                        <div class="mt-3">
                                            <div class="flex space-x-1">
                                                <div class="h-auto flex items-center">
                                                    <p class=" font-serif text-xl">{{ transformAmount(article.prix) }}</p>
                                                </div>
                                                <div class="h-auto flex items-center">
                                                    <svg class="h-6 fill-black" version="1.0"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 433.000000 577.000000"
                                                        preserveAspectRatio="xMidYMid meet">

                                                        <g transform="translate(0.000000,577.000000) scale(0.100000,-0.100000)"
                                                            stroke="none">
                                                            <path d="M2248 5551 c-352 -49 -603 -368 -568 -719 16 -151 64 -290 185 -532
                                                        36 -71 65 -132 65 -135 0 -3 -13 -5 -28 -5 -69 0 -238 39 -531 121 -373 106
                                                        -480 129 -593 129 -105 0 -124 -11 -114 -65 11 -58 41 -80 124 -93 256 -38
                                                        496 -294 625 -668 79 -226 108 -444 108 -794 0 -598 -66 -944 -216 -1133 -59
                                                        -74 -96 -97 -158 -97 -81 0 -150 45 -177 114 -23 62 20 126 85 126 36 0 82 38
                                                        91 77 4 13 4 52 2 87 -9 145 -123 217 -341 216 -132 -1 -213 -43 -277 -142
                                                        -54 -83 -67 -156 -47 -259 45 -221 189 -377 393 -425 53 -12 101 -15 204 -11
                                                        156 5 251 30 358 94 58 34 156 125 178 165 8 15 39 13 409 -28 220 -25 401
                                                        -46 402 -48 6 -5 -28 -251 -48 -350 -44 -221 -106 -361 -199 -448 -62 -58
                                                        -128 -82 -230 -82 -167 -2 -264 88 -230 213 17 63 61 106 141 138 82 33 146
                                                        83 165 130 22 51 17 131 -9 178 -46 81 -202 128 -351 105 -136 -21 -248 -95
                                                        -329 -218 -105 -159 -148 -374 -102 -507 57 -165 214 -317 408 -395 138 -55
                                                        195 -65 387 -64 161 1 182 3 265 28 223 68 374 196 471 401 82 174 114 353
                                                        114 657 l0 196 63 7 c208 22 350 61 502 138 83 43 115 66 191 142 98 97 144
                                                        172 184 300 31 97 39 330 16 462 -20 115 -63 236 -118 327 -54 92 -174 211
                                                        -264 264 -103 60 -110 91 -35 141 250 161 192 565 -108 759 -70 46 -183 86
                                                        -281 101 -36 5 -162 13 -280 16 -118 3 -232 9 -254 13 l-38 7 -78 225 c-43
                                                        124 -81 234 -86 245 -5 13 9 5 40 -23 75 -69 124 -87 236 -87 87 0 100 3 163
                                                        33 200 98 307 324 252 532 -41 153 -166 306 -306 373 -124 60 -295 87 -431 68z
                                                        m-127 -1758 c75 -167 166 -410 156 -419 -3 -3 -57 -2 -120 2 l-115 7 -12 45
                                                        c-31 124 -110 284 -186 379 -19 23 -34 44 -34 47 0 3 63 6 140 6 l141 0 30
                                                        -67z m665 48 c60 -27 114 -80 140 -136 68 -144 -19 -271 -217 -318 -25 -6 -27
                                                        -4 -39 51 -12 53 -93 364 -106 405 -5 15 4 17 88 17 69 0 104 -5 134 -19z
                                                        m279 -840 c73 -33 127 -112 159 -232 68 -264 -18 -558 -223 -759 -64 -63 -116
                                                        -99 -126 -88 -3 3 -10 76 -15 164 -18 290 -46 543 -97 897 l-6 37 134 0 c108
                                                        0 142 -4 174 -19z m-676 -53 c43 -218 61 -463 61 -814 l0 -284 -350 0 c-192 0
                                                        -350 3 -350 7 0 4 20 45 44 92 83 161 170 405 230 641 30 121 32 136 17 141
                                                        -14 6 -14 8 2 14 14 6 17 20 17 71 0 48 3 64 14 64 9 0 16 18 20 54 7 54 8 55
                                                        44 59 20 2 83 4 139 5 l102 2 10 -52z m-309 -28 c0 -5 -4 -10 -10 -10 -5 0
                                                        -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z" />
                                                        </g>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-full border-b-[1px] border-gray-400 text-red-500">
                                            <p class="">{{ $t('touslesprixincluentlatva') }}.</p>
                                        </div>
                                        <div>
                                            <p class="font-semibold underline">{{ $t('aproposdecetarticle') }}</p>
                                        </div>
                                    </div>
                                    <div class="w-full h-[65%] overflow-y-auto no-scrollbar">
                                        <div class="text-gray-500 underline">
                                            <p>{{ $t('description') }}</p>
                                        </div>
                                        <div class="text-[13px] text-justify">
                                            <p>{{ article.description }}</p>
                                        </div>
                                        <ul class="max-w-md space-y-1 text-gray-500 list-inside dark:text-gray-400 mt-3">
                                            <li v-if="article.couleur" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('couleur') }}: <span class="text-black font-semibold">{{
                                                    article.couleur
                                                }}</span></p>
                                            </li>
                                            <li v-if="article.taille" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('taille') }}: <span class="text-black font-semibold font-serif">{{
                                                    article.taille }}</span></p>
                                            </li>
                                            <li v-if="article.ville" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('ville') }}: <span class="text-black font-semibold font-serif">{{
                                                    article.ville }}</span></p>
                                            </li>
                                            <li v-if="article.stockage" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('stockage') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.stockage }} Go</span></p>
                                            </li>
                                            <li v-if="article.pixel_camera_avant" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('pixelcameraavant') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.pixel_camera_avant }}
                                                        mégapixel</span></p>
                                            </li>
                                            <li v-if="pixel_camera_arriere" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('pixelcameraarriere') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.pixel_camera_arriere
                                                        }} mégapixel</span></p>
                                            </li>
                                            <li v-if="article.ram" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('ram') }}: <span class="text-black font-semibold font-serif">{{
                                                    article.ram
                                                }} Go</span></p>
                                            </li>
                                            <li v-if="article.empreinte == 'oui'" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('empreinte') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.empreinte }}</span></p>
                                            </li>
                                            <li v-if="article.empreinte == 'non'" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-gray-500 dark:text-gray-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('empreinte') }}: <span class=" font-semibold font-serif">{{
                                                    article.empreinte }}</span></p>
                                            </li>
                                            <li v-if="article.cpu" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('cpu') }}: <span class="text-black font-semibold font-serif">{{
                                                    article.cpu
                                                }} Ghz</span></p>
                                            </li>
                                            <li v-if="article.systeme_exploitation" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('systemedexploitation') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.systeme_exploitation
                                                        }}</span></p>
                                            </li>
                                            <li v-if="article.carte_graphique_dedie" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('cartegraphiquededie') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.carte_graphique_dedie
                                                        }} Go</span></p>
                                            </li>
                                            <li v-if="article.etat" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('etatsur10') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.etat }}/10</span></p>
                                            </li>
                                            <li v-if="article.taille_pouce" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('tailleenpouce') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.taille_pouce }} Pouces</span></p>
                                            </li>
                                            <li v-if="article.quantite_litre" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('quantiteenlitre') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.quantite_litre }} litre</span></p>
                                            </li>
                                            <li v-if="article.quartier" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('quartier') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.quartier }}</span></p>
                                            </li>
                                            <li v-if="article.superficie" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('superficie') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.superficie }} Mètre carré</span></p>
                                            </li>
                                            <li v-if="article.nombre_piece" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('nombredepiece') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.nombre_piece }} pièce(s)</span></p>
                                            </li>
                                            <li v-if="article.nombre_chambre" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('nombredechambre') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.nombre_chambre }} chambre(s)</span></p>
                                            </li>
                                            <li v-if="article.nombre_salon" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('nombredesalon') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.nombre_salon }} Salon(s)</span></p>
                                            </li>
                                            <li v-if="article.nombre_douche" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('nombrededouche') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.nombre_douche }} Douche(s)</span></p>
                                            </li>
                                            <li v-if="article.nombre_cuisine" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('nombredecuisine') }}: <span
                                                        class="text-black font-semibold font-serif">{{
                                                            article.nombre_cuisine }} Cuisine(s)</span></p>
                                            </li>
                                            <li v-if="article.numero_direct" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('numerodirect') }}: <span
                                                        class="text-black font-semibold font-serif">+237
                                                        {{ article.numero_direct }}</span></p>
                                            </li>
                                            <li v-if="article.numero_whatsapp" class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('numerowhatsapp') }}: <span
                                                        class="text-black font-semibold font-serif">+237 {{
                                                            article.numero_whatsapp
                                                        }}</span></p>
                                            </li>
                                            <li class="flex items-center">
                                                <svg class="w-3.5 h-3.5 mr-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                                    aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor" viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                                                </svg>
                                                <p>{{ $t('quantitedisponible') }}: <span
                                                        class="text-black font-semibold font-serif">2</span></p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
// Import Swiper styles
import 'swiper/css';

import 'swiper/css/pagination';
export default {
    props: ['articleSelect'],
    components: {
        Swiper,
        SwiperSlide
    },
    data(props) {
        return {
            notearticle: 3,
            article: props.articleSelect,
            images: [],
            imageSelect: '',
            monProfil: '',
            auth: false,
            user: '',
            loadingDetail: false,
            error: '',
            wallet: '',
            relaiSelect: '',
            relais: '',
            hidFormPay: false,
            form: {
                cni_acheteur: '',
                numero_acheteur: '',
                article: '',
                montant: '',
                relai: '',
                walletId: '',
                password: ''
            },
            loadPay: false,
            hidInfoEtape: false,
        }
    },
    watch: {
        error: {
            handler(newValue) {
                if (newValue == 'not found') {
                    this.$nextTick(() => {
                        var child = document.getElementById('not-found')
                        this.$store.state.preview = child
                        console.log(this.$store.state.preview)
                    })

                }
            },
            deep: true
        },
    },
    beforeRouteLeave() {
        window.emitter.off("reloadDetailPage")
    },

    mounted() {
        this.loadingDetail = true
        this.imageSelect = this.$articleImage(this.article, 'image0', 'detail')
        this.images = this.$articleImages(this.article, 'detail')
    },
    methods: {
        transformAmount(value) {
            var result = ''
            if (value > 0) {
                var text = Math.round(value).toString()
                var countElement = ''
                for (let i = 1; i <= text.length; i++) {
                    result = text[text.length - i] + result
                    countElement += text[text.length - i]
                    if (countElement.length < text.length && countElement.length % 3 == 0) {
                        result = (localStorage.getItem('langue') == 'fr' ? ',' : '.') + result
                    }
                }
            } else {
                result = value
            }

            return result
        },


    },
    computed: {
        requestHttp() {
            return this.$store.state.api
        },
        requestFile() {
            return this.$store.state.apifile
        },
    }
}
</script>

<style>
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.mySwiperRelai {
    width: 100%;
    height: auto;
}

.mySwiperRelai {
    padding: 4px;
}

.swiper-relai {
    font-size: 18px;
    background: #fff;
    height: 11rem !important;
    width: 14rem !important;
}

.loader {
    --size-loader: 1.5rem;
    --size-orbe: 10px;
    width: var(--size-loader);
    height: var(--size-loader);
    position: relative;
    transform: rotate(45deg);
}

.orbe {
    position: absolute;
    width: 100%;
    height: 100%;
    --delay: calc(var(--index) * 0.1s);
    animation: orbit7456 ease-in-out 1.5s var(--delay) infinite;
    opacity: calc(1 - calc(0.2 * var(--index)));
}

.orbe::after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: var(--size-orbe);
    height: var(--size-orbe);
    background-color: #03ff5b;
    box-shadow: 0px 0px 20px 2px #03ff5b;
    border-radius: 50%;
}

@keyframes orbit7456 {
    0% {}

    80% {
        transform: rotate(360deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.load-row div span {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #03ff5b;
    border-radius: 50px;
    animation: up-down6 0.5s ease-in infinite alternate;
}

.load-row div span:nth-child(2) {
    background: #04e876c4;
    animation-delay: 0.16s;
}

.load-row div span:nth-child(3) {
    background: #04e85091;
    animation-delay: 0.32s;
}

.load-row div span:nth-child(4) {
    background: #04e88556;
    animation-delay: 0.48s;
}

@keyframes up-down6 {
    0% {
        transform: translateY(-100%);
    }

    100% {
        transform: translateY(50%);
    }
}
</style>
